import Api from "./Api";
import { Conversation, ConversationMessage, Widget } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class ConversationsController extends Api {
  static getConversation(id: string) {
    return fetch(`/api/conversations/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getConversations(params: object) {
    return fetch(`/api/conversations?${SearchHelper.getQueryString(params)}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static create(conversation: Conversation) {
    return fetch("/api/conversations", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ conversation: conversation }),
    }).then((res) => res.json());
  }

  static update(conversation: Conversation) {
    return fetch(`/api/conversations/${conversation.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ conversation: conversation }),
    }).then((res) => res.json());
  }

  static delete(id: string) {
    return fetch(`/api/conversations/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static bulkOpen(ids: string[]) {
    return fetch(`/api/conversations/open`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ conversation_ids: ids }),
    }).then((res) => res.json());
  }

  static bulkClose(ids: string[]) {
    return fetch(`/api/conversations/close`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ conversation_ids: ids }),
    }).then((res) => res.json());
  }

  static getConversationView(id: string): Promise<{
    conversation: Conversation;
    widget: Widget;
  }> {
    return fetch(`/api/conversations/${id}/view`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static reply(
    conversationId: string,
    message: ConversationMessage
  ): Promise<Conversation> {
    return fetch(`/api/conversations/${conversationId}/reply`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ message: message }),
    }).then((res) => res.json());
  }

  static read(conversationId: string): Promise<Conversation> {
    return fetch(`/api/conversations/${conversationId}/read`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getCounters(): Promise<{
    all: number;
    me: number;
    unassigned: number;
  }> {
    return fetch(`/api/conversations/counters`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }
}
